import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mapAccounts } from 'actions/accountsActions';
import { caItemsFromString } from 'utils/stateToState';

class MapAccountsModal extends Component {
  constructor(props) {
    super(props);
    let [caItems, duplicates] = caItemsFromString(this.props.data.caString);
    this.state = {
      caItems,
      duplicates,
    };
  }

  /*
   * For currently selected CA file checks and returns array of messages
   */
  updateMessages() {
    console.log(
      `Imported chart of accounts file has ${
        this.props.data.caString.split('\n').length
      } lines.`
    );
    let ret = [];
    if (this.state.duplicates.length === 0) {
      ret.push(
        `Imported chart of accounts file has ${this.state.caItems.size} items.`
      );
      ret.push(
        `Warning: If you proceed all groups will be deleted and new ones will be created.`
      );
    } else {
      ret.push(
        `Imported chart of accounts file has ${
          this.state.caItems.size
        } items with distinct number and ${
          this.state.duplicates.length
        } duplicates: ${this.state.duplicates.join(', ')}.`
      );
      ret.push(`Please remove duplicates and try to map again.`);
    }
    return ret;
  }

  render() {
    const messages = this.updateMessages().map((msg, i) => (
      <p key={i}>{msg}</p>
    ));

    return (
      <div className="MapAccountsModal">
        <h2>Map accounts</h2>
        <div className="messages">{messages}</div>
        <form onSubmit={this.handleSubmit}>
          <input
            type="submit"
            value="Map"
            className="btn"
            disabled={this.state.duplicates.length > 0}
          />
        </form>
      </div>
    );
  }

  handleSubmit = (event) => {
    this.props.mapAccounts(this.state.caItems);
    this.props.onClose();
    event.preventDefault();
  };
}

export default connect(
  (state) => ({
    accounts: state.accounts,
  }),
  { mapAccounts }
)(MapAccountsModal);
